import type { AxiosResponse } from 'axios';

import type { ResponseWithPagination } from '@/utils/types';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type {
  CampaignFilters, CampaignNames, CampaignText,
  StaticCampaignBody,
} from '../campaigns/types';
import type {
  ITabletWidgetAdv,
  IImageWidgetResponce,
  ToggleModerationWidgetAd,
  WidgetType,
  ToggleStatusWidgets,
} from './types';


export const update = (data: ITabletWidgetAdv)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: ROUTES.TABLET_WIDGETS,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const uploadWidgetPhoto = (data: File, type: WidgetType)
  : Promise<void | AxiosResponse<IImageWidgetResponce>> => axiosInstance({
  url: `images?adv_type=tablet_widget&type=${type}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getImage = (hash: string)
  : Promise<void | AxiosResponse<File>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/ref-photo/${hash}`,
  method: 'GET',
  responseType: 'arraybuffer',
  headers: {
    authorization: true,
  },
});


export const getById = (id: string)
  : Promise<void | AxiosResponse<ITabletWidgetAdv>> => axiosInstance({
  url: `${ROUTES.TABLET_WIDGETS}/${id}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getAll = (data: Partial<StaticCampaignBody>)
  : Promise<void | AxiosResponse<ResponseWithPagination<ITabletWidgetAdv>>> => axiosInstance({
  url: `${ROUTES.TABLET_WIDGETS}/select`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const toggleModerationWidgetAd = (adsId: string, data: ToggleModerationWidgetAd)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.TABLET_WIDGETS}/${adsId}/admin-mod`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const toggleStatusWidgets = (id: string, data: ToggleStatusWidgets)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.TABLET_WIDGETS}/${id}`,
  method: 'PATCH',
  headers: {
    authorization: true,
  },
  data,
});


///////////////////////////

export const toggleArchivedCampaign = (id: string, data: Pick<IStaticAdv, 'archived'>)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/${id}`,
  method: 'PATCH',
  headers: {
    authorization: true,
  },
  data,
});

export const getFilters = (): Promise<void | AxiosResponse<Pick<CampaignFilters, 'org'>>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/select/filters`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getNames = (data: CampaignText<StaticAdvType[]>)
    : Promise<void | AxiosResponse<CampaignNames>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/select/names`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});
